var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"mr-4 ml-4"},[_c('v-autocomplete',{key:_vm.keyName,attrs:{"label":_vm.$t(_vm.title) + '*',"disabled":_vm.disabled,"item-text":_vm.itemText,"item-value":_vm.itemValue,"items":_vm.items,"error-messages":_vm.errorMessage,"required":""},on:{"change":_vm.onChange,"click":() => {
        this.wasBlurred = true;
      }},model:{value:(_vm.selectedData),callback:function ($$v) {_vm.selectedData=$$v},expression:"selectedData"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }